import IconCard from 'Support/components/cards/IconCard.vue';

export default {
  components: {
    IconCard,
  },
  data: () => ({
    options: [],
  }),
  methods: {
    buildCardOption(icon, text, route) {
      return {
        backgroundIconColor: '#FFE6E7',
        icon,
        iconColor: 'red',
        text,
        route,
      };
    },
  },
  computed: {
    cardOptions() {
      return this.options;
    },
  },
};
